import moment from "moment";
import React, { useState } from "react";
// import BasicPagination from "../../../../Pagination/Pagination";
import { Table, Image, Button } from "react-bootstrap";
import BasicPagination from "../../../../Pagination/Pagination";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

function MiscellaneousPageComponent(props) {
  //state
  const [insidePageTab, setInsidePageTab] = useState("1");

  const pageChangeButtonClickHandler = (value) => (e) => {
    setInsidePageTab(value);
  };

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        (item?.restaurant_id?.restaurant_name
          ? item?.restaurant_id?.restaurant_name
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false) ||
        (item?.order_id?.order_id
          ? item?.order_id?.order_id.includes(props.search)
          : false) ||
        (item?.restaurant_id?.area
          ? item?.restaurant_id?.area
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false) ||
        (item?.event_id?.name
          ? item?.event_id?.name
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false) ||
        (item?.item_id?.name
          ? item?.item_id?.name
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false) ||
        (item?.offer_id?.name
          ? item?.offer_id?.name
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false) ||
        (item?.event_id?.event_id
          ? item?.event_id?.event_id
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false) ||
        (item?.offer_id?.coupon_code
          ? item?.offer_id?.coupon_code
              ?.toLowerCase()
              .includes(props.search.toLowerCase())
          : false)
      );
    });
  }

  if (props.sortBy === "Date & Time 🠑") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Date & Time 🠓") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (props.filterBy) {
    if (props?.filterBy?.type)
      filteredData = filteredData?.filter((ele) => {
        if (props?.filterBy?.type == "used") return ele.used;
        if (props?.filterBy?.type == "viewed") return ele.viewed;
      });
  }

  const restData = filteredData?.filter((e) => e.type === 1);
  const offerData = filteredData?.filter((e) => e.type === 2);
  const eventData = filteredData?.filter((e) => e.type === 3);
  const itemData = filteredData?.filter((e) => e.type === 4);
  const streamData = filteredData?.filter((e) => e.type === 5);

  return (
    <>
      <div className="row super_admin_all_users_toggle_button-tab">
        <div className="col-9 super_admin_all_users_toggle_button-tab">
          <div className="Right-side-heading-text ml-0">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "1" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("1")}
              >
                Restaurants
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "2" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("2")}
              >
                Offers
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "3" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("3")}
              >
                Events
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "4" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("4")}
              >
                Items
              </Button>
            </div>
          </div>
        </div>
      </div>
      {insidePageTab === "1" && (
        <Restaurants data={restData} start={start} end={end} />
      )}
      {insidePageTab === "2" && (
        <Offers data={offerData} start={start} end={end} />
      )}
      {insidePageTab === "3" && (
        <Events data={eventData} start={start} end={end} />
      )}
      {insidePageTab === "4" && (
        <Items data={itemData} start={start} end={end} />
      )}

      {/* {filteredData.length !== 0 ? (*/}
      <BasicPagination
        totalRecords={
          insidePageTab === "1"
            ? restData.length
            : insidePageTab === "2"
            ? offerData.length
            : insidePageTab === "3"
            ? eventData.length
            : insidePageTab === "4"
            ? itemData.length
            : insidePageTab === "5"
            ? streamData.length
            : 0
        }
        limit={10}
        batch={page}
        onBatchChange={(e) => handleBatchChange(e)}
      />
      {/*) : (
        <></>
      )} */}
    </>
  );
}

export default MiscellaneousPageComponent;

const Restaurants = ({ data, start, end, ...props }) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "25%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "75%" }} className="f12-700">
              Viewed
            </th>
          </tr>
        </thead>
        <tbody className="HideShowTable">
          {data.slice(start, end).map((item, index) => (
            <tr
              className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
              key={index}
            >
              <td style={{ width: "25%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      src={item?.restaurant_id?.logo_url || NOTAVAILABLEIMAGE}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">
                    {item?.restaurant_id?.restaurant_name || ""}
                  </div>
                </div>
              </td>
              <td style={{ width: "75%" }}>
                <div className="f15-700">{item?.viewed ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

const Offers = ({ data, start, end, ...props }) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Offers
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Viewed
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Offers
              <br />
              Availed
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Offer Code
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Offer Start
              <br />
              End Date
            </th>
          </tr>
        </thead>
        {data.slice(start, end).map((item, index) => (
          <tbody className="HideShowTable">
            <tr
              className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
              key={index}
            >
              <td style={{ width: "20%" }}>
                <div className="d-flex flex-column align-items-start">
                  {item?.restaurant_id ? (
                    <>
                      {" "}
                      <div className="enImage45 ">
                        <Image
                          src={
                            item?.restaurant_id?.logo_url || NOTAVAILABLEIMAGE
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                      </div>
                      <div className="f11-500 text-center mt-1">
                        {item?.restaurant_id?.restaurant_name || ""}
                      </div>
                    </>
                  ) : (
                    <div className="f11-500 text-center mt-1">N/A</div>
                  )}
                </div>
              </td>
              <td style={{ width: "25%" }}>
                <div className="d-flex align-items-center">
                  <div className="text-center d-flex flex-column align-items-center">
                    <div className="enIMG62">
                      <Image
                        src={
                          item?.offer_id?.photo_thumbnails.length
                            ? item?.offer_id?.photo_thumbnails[0] ||
                              NOTAVAILABLEIMAGE
                            : item?.offer_id?.photos[0] || NOTAVAILABLEIMAGE
                        }
                        alt="Offer img"
                        title="Offer img"
                        fluid
                      />
                    </div>
                    <div className="enPendingLBL mt-2">
                      {item?.offer_id?.isOnline ? "Online" : "Offline"}
                    </div>
                  </div>
                  <div className="pl-3">
                    <div className="f12-500">{item?.offer_id?.name}</div>

                    <div className="f10-500 opacity5">
                      {item?.offer_id?.description}
                    </div>
                  </div>
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f15-700">{item?.viewed ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f15-700">{item?.used ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-500">{item?.offer_id?.coupon_code}</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-400">
                  {moment(item?.offer_id?.start_date).format("Do MMM  YY")}-
                </div>
                <div className="f14-400 text-red">
                  {moment(item?.offer_id?.end_date).format("Do MMM  YY")}
                </div>
              </td>
            </tr>
          </tbody>
        ))}
      </Table>
    </div>
  );
};

const Events = ({ data, start, end, ...props }) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Event
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Viewed
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Attented
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Event Code
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Event Start Date
              <br />
              End Date
            </th>
          </tr>
        </thead>
        {data.slice(start, end).map((item, index) => (
          <tbody className="HideShowTable">
            <tr
              className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
              key={index}
            >
              <td style={{ width: "20%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      src={item?.restaurant_id?.logo_url || NOTAVAILABLEIMAGE}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">
                    {item?.restaurant_id?.restaurant_name || ""}
                  </div>
                </div>
              </td>
              <td style={{ width: "25%" }}>
                <div className="d-flex align-items-center">
                  <div className="text-center d-flex flex-column align-items-center">
                    <div className="enIMG62">
                      <Image
                        src={
                          item?.event_id?.photo_thumbnails.length
                            ? item?.event_id?.photo_thumbnails[0] ||
                              NOTAVAILABLEIMAGE
                            : item?.event_id?.photos[0] || NOTAVAILABLEIMAGE
                        }
                        alt="Offer img"
                        title="Offer img"
                        fluid
                      />
                    </div>
                    <div className="enPendingLBL mt-2">
                      {item?.event_id?.isOnline ? "Online" : "Offline"}
                    </div>
                  </div>
                  <div className="pl-3">
                    <div className="f12-500">{item?.event_id?.name}</div>

                    <div className="f10-500 opacity5">
                      {item?.event_id?.description}
                    </div>
                  </div>
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f15-700">{item?.viewed ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f15-700">{item?.used ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f14-500">{item?.event_id?.event_id}</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-400">
                  {moment(item?.event_id?.start_date).format("Do MMM  YY")}-
                </div>
                <div className="f14-400 text-red">
                  {moment(item?.event_id?.end_date).format("Do MMM  YY")}
                </div>
              </td>
            </tr>
          </tbody>
        ))}
      </Table>
    </div>
  );
};

const Items = ({ data, start, end, ...props }) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Item Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Viewed
            </th>
            <th style={{ width: "30%" }} className="f12-700">
              Ordered
            </th>
          </tr>
        </thead>
        {data.slice(start, end).map((item, index) => (
          <tbody className="HideShowTable">
            <tr
              className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
              key={index}
            >
              <td style={{ width: "20%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      src={item?.restaurant_id?.logo_url || NOTAVAILABLEIMAGE}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">
                    {item?.restaurant_id?.restaurant_name || ""}
                  </div>
                </div>
              </td>
              <td style={{ width: "25%" }}>
                <div className="d-flex align-items-center">
                  <div className="text-center d-flex flex-column align-items-center">
                    <div className="enIMG62">
                      <Image
                        src={
                          item?.item_id?.image_thumbnails?.length
                            ? item?.item_id?.image_thumbnails[0] ||
                              NOTAVAILABLEIMAGE
                            : item?.item_id?.images[0] || NOTAVAILABLEIMAGE
                        }
                        alt="Offer img"
                        title="Offer img"
                        fluid
                      />
                    </div>
                  </div>
                  <div className="pl-3">{item?.item_id?.name || ""}</div>
                </div>
              </td>
              <td style={{ width: "25%" }}>
                <div className="f15-700">{item?.viewed ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
              <td style={{ width: "30%" }}>
                <div className="f15-700">{item?.used ? "Yes" : "No"}</div>
                <div className="f15-700">
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("DD MMM YYYY")}
                  </div>
                  <div className="f12-400">
                    {" "}
                    {moment(item?.createdAt).format("LT")}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        ))}
      </Table>
    </div>
  );
};
